import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function PendingAnswerIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 438.000000 448.000000"
      preserveAspectRatio="xMidYMid meet">

      <g
        transform="translate(0.000000,448.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path d="M2100 4420 c-19 -19 -20 -33 -20 -500 0 -467 1 -481 20 -500 11 -11
          31 -20 45 -20 14 0 34 9 45 20 19 19 20 33 20 500 0 467 -1 481 -20 500 -11
          11 -31 20 -45 20 -14 0 -34 -9 -45 -20z"
        />
        <path d="M332 4164 c-15 -10 -22 -25 -22 -47 0 -28 36 -68 343 -374 305 -306
          346 -343 374 -343 40 0 63 23 63 63 0 28 -37 69 -343 374 -361 362 -363 363
          -415 327z"
        />
        <path d="M3543 3838 c-308 -307 -343 -346 -343 -375 0 -40 23 -63 63 -63 28 0
          69 37 374 343 366 366 370 370 323 417 -47 47 -51 43 -417 -322z"
        />
        <path d="M1490 2989 c-127 -25 -248 -119 -308 -239 -15 -30 -70 -206 -123
          -390 l-96 -335 -64 -35 c-98 -54 -209 -171 -258 -272 -22 -46 -45 -103 -52
          -128 -9 -32 -13 -203 -16 -578 -5 -611 -5 -611 71 -686 67 -67 109 -79 273
          -74 136 3 139 3 188 35 97 63 116 112 123 320 l5 163 912 0 912 0 5 -163 c7
          -208 26 -257 123 -320 49 -32 52 -32 188 -35 164 -5 206 7 273 74 76 75 76 75
          71 686 -3 375 -7 546 -16 578 -7 25 -30 82 -52 128 -49 101 -160 218 -258 272
          l-64 35 -96 335 c-53 184 -109 361 -126 393 -56 111 -186 209 -313 236 -64 13
          -1233 14 -1302 0z m1352 -152 c63 -31 118 -87 149 -150 12 -23 58 -168 103
          -322 l82 -280 -519 -3 c-285 -1 -749 -1 -1031 0 l-512 3 82 280 c45 154 91
          298 102 321 42 85 114 147 202 171 34 9 196 12 665 10 l620 -2 57 -28z m336
          -902 c196 -46 356 -209 397 -402 11 -50 15 -144 15 -350 l0 -283 -1445 0
          -1445 0 0 283 c0 321 8 377 66 487 65 125 202 231 342 264 88 22 1979 22 2070
          1z m-2079 -1319 c-4 -138 -6 -158 -25 -183 -35 -47 -68 -58 -181 -58 -87 0
          -106 3 -130 21 -53 39 -63 74 -63 232 l0 142 201 0 201 0 -3 -154z m2491 12
          c0 -158 -10 -193 -63 -232 -24 -18 -43 -21 -130 -21 -113 0 -146 11 -181 58
          -19 25 -21 45 -25 183 l-3 154 201 0 201 0 0 -142z"
        />
        <path d="M1163 1676 c-121 -26 -194 -121 -194 -252 0 -152 104 -256 256 -256
          109 -1 203 58 243 151 21 51 21 156 -1 213 -20 51 -80 112 -131 133 -48 19
          -116 24 -173 11z m123 -135 c34 -15 45 -28 59 -65 31 -80 -4 -154 -82 -175
          -73 -21 -147 21 -162 91 -15 70 21 139 83 157 45 13 57 12 102 -8z"
        />
        <path d="M3008 1680 c-142 -24 -230 -163 -198 -315 38 -185 268 -260 426 -140
          82 62 110 214 60 322 -47 101 -163 154 -288 133z m129 -146 c36 -23 55 -60 55
          -109 0 -77 -50 -128 -125 -128 -61 0 -101 25 -121 75 -30 73 -7 138 59 169 44
          21 93 18 132 -7z"
        />
      </g>
    </svg>

  )
}